<template>
  <div class="search-user-asset-header-container">
    <ValidationObserver ref="form">
      <CRow>
        <CCol md="3" sm="12">
          <ValidationProvider name="SEARCH_USER_ASSET_HEADER_COMPONENT_FIELD_NAME_VALIDATE_DATE_RANGE" v-slot="{ errors }" rules>
            <div role="group" class="form-group">
              <label class>{{ $t('SEARCH_USER_ASSET_HEADER_COMPONENT_LABEL_DATE_RANGE') }}</label>
              <div class="input-group1">
                <date-range-picker
                  v-model="searchData.dateRange"
                  :locale-data="dateRangeOption.localeData"
                  :always-show-calendars="dateRangeOption.alwaysShowCalendars"
                  :append-to-body="dateRangeOption.appendToBody"
                  :ranges="dateRangeOption.showRanges"
                  :auto-apply="dateRangeOption.autoApply"
                ></date-range-picker>
              </div>
            </div>
            <span class="error-msg-wrap">
              <span class="error-msg">{{ errors[0] }}</span>
            </span>
          </ValidationProvider>
        </CCol>

        <CCol md="3" sm="12">
          <div role="group" class="form-group form-group">
            <label class>{{ $t('SEARCH_USER_ASSET_HEADER_COMPONENT_PLATFORM_LABEL') }}</label>
            <select @change="onChangePlatform($event)" v-model="searchData.cryptoPlatform" class="form-control">
              <option value>{{ $t('SEARCH_USER_ASSET_HEADER_COMPONENT_ALL_PLATFORMS_LABEL') }}</option>
              <option v-for="item in platformList" :key="item.value" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
        </CCol>

        <CCol md="3" sm="12">
          <ValidationProvider name="SEARCH_USER_ASSET_HEADER_COMPONENT_ADDRESS_FIELD_NAME" v-slot="{ errors }" rules>
            <CInput
              :label="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_ADDRESS_LABEL')"
              type="text"
              v-model="searchData.address"
              class="form-group"
              @keyup.enter="search()"
            />
            <CRow>
              <CCol :md="12">
                <span class="error-msg mt-1">{{ errors[0] }}</span>
              </CCol>
            </CRow>
          </ValidationProvider>
        </CCol>

        <CCol md="3" sm="12">
          <ValidationProvider name="SEARCH_USER_ASSET_HEADER_COMPONENT_EMAIL_FIELD_NAME" v-slot="{ errors }" rules>
            <CInput
              :label="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_EMAIL_LABEL')"
              type="text"
              v-model="searchData.email"
              class="form-group"
              @keyup.enter="search()"
            />
            <CRow>
              <CCol :md="12">
                <span class="error-msg mt-1">{{ errors[0] }}</span>
              </CCol>
            </CRow>
          </ValidationProvider>
        </CCol>

        <CCol v-show="hasFilterPlatform" md="3" sm="12">
          <ValidationProvider
            :name="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_BALANCE_FROM_FIELD_NAME', { currencySymbol: searchData.cryptoPlatform })"
            v-slot="{ errors }"
            rules=""
          >
            <CInput
              :label="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_BALANCE_FROM_LABEL', { currencySymbol: searchData.cryptoPlatform })"
              type="text"
              v-model="searchData.balanceFrom"
              class="form-group"
              @keyup.enter="search()"
            />
            <CRow>
              <CCol :md="12">
                <span class="error-msg mt-1">{{ errors[0] }}</span>
              </CCol>
            </CRow>
          </ValidationProvider>
        </CCol>

        <CCol v-show="hasFilterPlatform" md="3" sm="12">
          <ValidationProvider
            :name="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_BALANCE_TO_FIELD_NAME', { currencySymbol: searchData.cryptoPlatform })"
            v-slot="{ errors }"
            rules
          >
            <CInput
              :label="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_BALANCE_TO_LABEL', { currencySymbol: searchData.cryptoPlatform })"
              type="text"
              v-model="searchData.balanceTo"
              class="form-group"
              @keyup.enter="search()"
            />
            <CRow>
              <CCol :md="12">
                <span class="error-msg mt-1">{{ errors[0] }}</span>
              </CCol>
            </CRow>
          </ValidationProvider>
        </CCol>

        <CCol v-show="hasFilterPlatform" md="3" sm="12">
          <ValidationProvider
            :name="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_AMOUNT_FROM_FIELD_NAME', { currencySymbol: searchData.cryptoPlatform })"
            v-slot="{ errors }"
            rules
          >
            <CInput
              :label="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_AMOUNT_FROM_LABEL', { currencySymbol: searchData.cryptoPlatform })"
              type="text"
              v-model="searchData.amountFrom"
              class="form-group"
              @keyup.enter="search()"
            />
            <CRow>
              <CCol :md="12">
                <span class="error-msg mt-1">{{ errors[0] }}</span>
              </CCol>
            </CRow>
          </ValidationProvider>
        </CCol>

        <CCol v-show="hasFilterPlatform" md="3" sm="12">
          <ValidationProvider
            :name="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_AMOUNT_TO_FIELD_NAME', { currencySymbol: searchData.cryptoPlatform })"
            v-slot="{ errors }"
            rules
          >
            <CInput
              :label="$t('SEARCH_USER_ASSET_HEADER_COMPONENT_AMOUNT_TO_LABEL', { currencySymbol: searchData.cryptoPlatform })"
              type="text"
              v-model="searchData.amountTo"
              class="form-group"
              @keyup.enter="search()"
            />
            <CRow>
              <CCol :md="12">
                <span class="error-msg mt-1">{{ errors[0] }}</span>
              </CCol>
            </CRow>
          </ValidationProvider>
        </CCol>
      </CRow>
    </ValidationObserver>

    <CRow class="mt-2 form-actions">
      <CCol md="3" sm="12">
        <CButton class="btn btn-download-csv " @click="downloadCSV(false)">{{
          $t('SEARCH_USER_ASSET_HEADER_COMPONENT_BUTTON_DOWNLOAD_CSV')
        }}</CButton>
      </CCol>
      <CCol md="3" sm="12">
        <CButton class="btn btn-download-csv " @click="downloadCSV(true)">{{
          $t('SEARCH_USER_ASSET_HEADER_COMPONENT_BUTTON_DOWNLOAD_CSV_LATEST')
        }}</CButton>
      </CCol>
      <CCol md="3" sm="12">
        <CButton class="btn btn-reset" @click="resetForm()">{{ $t('SEARCH_USER_ASSET_HEADER_COMPONENT_RESET_BUTTON') }}</CButton>
      </CCol>

      <CCol md="3" sm="12">
        <CButton class="btn btn-search" @click="search()">{{ $t('SEARCH_USER_ASSET_HEADER_COMPONENT_SEARCH_BUTTON') }}</CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from 'moment';
import { Constants } from '@/constants';
import DateRangePicker from 'vue2-daterange-picker';
import stringHelper from '@/utils/string-helper';
import sessionStorageHelper from '@/utils/sessionStorage-helper';
import dateTimeHelper from '@/utils/datetime-helper';

export default {
  name: 'SearchUserAssetHeader',
  components: {
    DateRangePicker,
  },
  data() {
    return {
      searchData: sessionStorageHelper.getData(sessionStorageHelper.KEYS.FilterUserAssets) || this.getDefaultValues(),
      dateRangeOption: {
        alwaysShowCalendars: true,
        appendToBody: false,
        showRanges: false,
        autoApply: false,
        localeData: {
          firstDay: 1,
          format: 'yyyy/mm/dd',
          direction: 'ltr',
          separator: ' - ',
          applyLabel: 'Apply',
          cancelLabel: 'Cancel',
          weekLabel: 'W',
        },
      },
      dateTimePickerFormat: Constants.dateTimePickerFormat,
      hasFilterPlatform: false,
    };
  },
  props: {
    onSearch: {
      type: Function,
      default: null,
    },
    platformList: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    this.onChangePlatform();
    this.search();
  },
  methods: {
    getDefaultValues() {
      return {
        address: '',
        cryptoPlatform: '',
        email: '',
        dateRange: {
          startDate: null,
          endDate: null,
        },
        balanceFrom: '',
        balanceTo: '',
        amountFrom: '',
        amountTo: '',
        hasFilterPlatform: false,
      };
    },
    resetForm() {
      this.searchData = this.getDefaultValues();
      this.onChangePlatform();

      this.search();
    },
    async search() {
      this.searchData.dateRange.startDate = dateTimeHelper.startOfDate(this.searchData.dateRange.startDate);
      this.searchData.dateRange.endDate = dateTimeHelper.startOfDate(this.searchData.dateRange.endDate);
      sessionStorageHelper.setData(sessionStorageHelper.KEYS.FilterUserAssets, this.searchData);

      const searchData = {
        ...this.searchData,
        fromDate: this.searchData.dateRange.startDate,
        toDate: this.searchData.dateRange.endDate,
        hasFilterPlatform: this.hasFilterPlatform,
      };
      this.onSearch(searchData);
    },
    onChangePlatform() {
      this.hasFilterPlatform = !!this.searchData.cryptoPlatform;
    },
    downloadCSV(onlyLatest = false) {
      this.searchData.dateRange.startDate = dateTimeHelper.startOfDate(this.searchData.dateRange.startDate);
      this.searchData.dateRange.endDate = dateTimeHelper.startOfDate(this.searchData.dateRange.endDate);
      sessionStorageHelper.setData(sessionStorageHelper.KEYS.FilterUserAssets, this.searchData);

      const searchData = {
        ...this.searchData,
        fromDate: this.searchData.dateRange.startDate,
        toDate: this.searchData.dateRange.endDate,
        hasFilterPlatform: this.hasFilterPlatform,
        onlyLatest: onlyLatest
      };
      this.$emit('downloadCSV', searchData);
    }
  },
};
</script>

<style lang="scss">
.search-user-asset-header-container {
  margin-bottom: 35px;
  .form-search {
    margin-bottom: 5px;
  }

  .vue-daterange-picker {
    width: 100%;
    .reportrange-text {
    }
    .daterangepicker {
      position: absolute;
      top: 35px;
      left: 0;
      transform: unset;
      padding: 0;
      z-index: 99;
      &::after,
      &::before {
        left: 80px;
        right: unset;
      }
      .calendars-container {
        flex-wrap: wrap;
      }
    }
    .fa.fa-calendar {
      display: none;
    }
  }

  .form-actions {
    .btn {
      border: none;
      border-radius: 32px;
      height: 32px;
      padding: 0 30px;
      color: #fff;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 14px;
      text-align: center;
      border: 1px solid #1a2958;
      border-radius: 17.5px;
      background-color: #1a2958;
      width: 100%;
      display: block;

      &.btn-search {
      }

      &.btn-reset,
      &.btn-download-csv {
        color: #1a2958;
        background-color: #fff;
      }
    }
  }
}
</style>
